import { ProductExchangeOrSectionInfoSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/product-exchange-recommendation";
import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getPersonalizedRecommendationsStream = unaryStreamRpc({
  name: "getPersonalizedRecommendationsStream" as const,
  input: z.object({
    draftReturnId: z.string(),
    currentReturnProductId: z.string(),
    selectedProductsForReturn: z.array(ReturnProductSchema),
    waitForProductPreferences: z.boolean(),
  }),
  output: ProductExchangeOrSectionInfoSchema,
});
